import React, { useState, useRef, useEffect } from 'react';
import CheckSolid from "../../images/check-solid.svg";

interface ChatLanguageProps {
  language?: string;
  setLanguage?: (value: string) => void;
}

const ChatLanguage: React.FC<ChatLanguageProps> = ({
  language = 'English',
  setLanguage,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const languages = ["English", "Spanish"];

  const toggleDropdown = () => setIsOpen(prev => !prev);

  const handleSelect = (value: string) => {
    setLanguage?.(value);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="chat-option-wrap chat-language" ref={dropdownRef}>
      <label htmlFor="language">Language</label>
      <div className="custom-dropdown" onClick={toggleDropdown}>
        <div className="selected-option">
          <p className='no-select'></p><span>{language}</span>
        </div>
        {isOpen && (
          <div className="dropdown-options">
            {languages.map((lang) => (
              <div
                key={lang}
                className={`dropdown-option ${language === lang ? 'selected' : ''}`}
                onClick={() => handleSelect(lang)}
              >
                {language === lang ? (
                  <img src={CheckSolid} alt="check" style={{ width: 16, height: 16 }} />
                ) : (<p className='no-select'></p>)}
                {lang}
              </div>
            ))}
          </div>
        )}
      </div>

      <input type="hidden" name="language" value={language} />
    </div>
  );
};

export default ChatLanguage;
